import {React, useState, useEffect} from 'react';
import styles from './dwn-style.module.css'; 
import { useLocation, useNavigate } from 'react-router-dom';



const FitAdminDashboard = () => {

    const location = useLocation();
    const [pid] = useState(location?.state?.pid )
    const[access, setAccess] = useState(-1)
    const navigate = useNavigate();

  const onboard_family = () => {
    navigate('/FitOnboardingDashboard', { state: {pid: pid} });

  };

  const onboarded_families = () => {
    navigate('/FitOnboardedDashboard', { state: {pid: pid} });
  };


  const signOut = () => {
    console.log("Signing out...");
    navigate('/');
  };

  useEffect(() => {
    if (pid == null) {
      navigate('/');
    } else {
      const body = { "username": pid, "scope": "participant" };
      let connectionString = "https://app.digitalwellnessnurse.com"; //https://app.digitalwellnessnurse.com  http://localhost:2001
  
      fetch(`${connectionString}/api/portal/verify`, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        credentials: "include",
        body: JSON.stringify(body),
      })
        .then((response) => {
          setAccess(response.status);
          return response.json();
        })
        .then((json) => {
          if (json.access !== 200) {
            navigate('/');

          } 
        })
        .catch((error) => {
          console.error("Error verifying access:", error);
        });
    }
     }, [pid, navigate]); 

  return (
    <div className={styles.portal}>
      {/* Top Navigation */}
      <div className={styles.topRight}>
        <button onClick={signOut} type="button" className={styles.buttonLink}>
          Sign Out
        </button>
      </div>

      {/* Main Buttons */}
      <div className={styles.buttonContainer} style={{ display: 'flex', justifyContent: 'center', gap: '20px', marginTop: '50px' }}>
        <button onClick={onboard_family} className={styles.mainButton} style={{ backgroundColor: '#2F5597', color: 'white', fontSize: '18px', padding: '15px 30px' }}>
          Onboard a Family
        </button>
        <button onClick={onboarded_families} className={styles.mainButton} style={{ backgroundColor: '#2F5597', color: 'white', fontSize: '18px', padding: '15px 30px' }}>
          Participating Families
        </button>
      </div>
    </div>
  );
};

export default FitAdminDashboard;
